module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/crocodile-star3.87c36ec8.png";